document.addEventListener("click", function (evt) {
    var dropdownElem = document.getElementById('js-sort-dropdown'),
        toggleSortMenu = document.getElementById('js-toggle-sort-menu'),
        targetElement = evt.target;

    do {
        if (targetElement == dropdownElem) {
            // This is a click inside
            return;
        }
        // Go up the DOM
        targetElement = targetElement.parentNode;
    } while (targetElement);

    // Click outside
    if (toggleSortMenu) {
        toggleSortMenu.setAttribute("checked", ""); // For IE
        toggleSortMenu.removeAttribute("checked"); // For other browsers
        toggleSortMenu.checked = false;
    }
});